import { Box, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react';
import GeneratedReportService from '../../../shared/services/generated-report/generatedReport.service';
import { IGeneratedSecrReportResponse } from '../../../shared/services/generated-report/generated-report.model';
import { ReportingSecrTable } from '../../../components/presentation-components/reporting-components/secr/reporting-secr-table';

export const SecrTableForPdf = () => {

  const params = useParams();
  const generatedReportService = new GeneratedReportService();
  const [report, setReport] = useState<IGeneratedSecrReportResponse>();

  useEffect(() => {
    if (!params.secrReportId) {
      return;
    }
    generatedReportService
      .getReport(params.secrReportId)
      .then((response) => {
        setReport(response);
      })
      .catch((err) => console.log(err));
  }, [params.secrReportId]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', maxWidth: '100%' }}>
      {report && (
        <Box data-secr-pdf-ready="true" sx={{ width: '100%' }}>
          <Typography
            variant='h4'
            sx={{ mb: 2, color: 'text.primary', fontWeight: 700 }}
          >
            Streamlined Energy and Carbon Report ({report.reportDetails[0].reportPeriodName})
          </Typography>
          <ReportingSecrTable report={report} showSignOff={true} />
        </Box>
      )}
    </Box>
  );
};
